<template>
    <a-dropdown :trigger="['click']" v-model="visible">
        <a-badge class="icon__notification" :count="count">
            <a-icon type="mail-custom" theme="filled" />
        </a-badge>
        <template #overlay>
            <div class="notifier__container">
                <ul v-if="notifications.length">
                    <li
                        v-for="notification in notifications"
                        :key="notification.id"
                        :class="{ read: notification.isRead }"
                    >
<!--                        <span class="notifier__icon">-->
<!--                            <a-icon type="mail" />-->
<!--                        </span>-->
                        <div class="notifier__body">
                            <h5>{{ notification.title }}</h5>
                            <p>{{ notification.content }}</p>
                            <p class="notifier__time">{{ notification.createTime }}</p>
                        </div>
                        <div class="notifier__operations" v-show="!notification.isRead">
                            <a-icon type="read" @click="click4read(notification)" />
                            <a-icon type="enter" @click="click4handle(notification)" />
                        </div>
                    </li>
                </ul>
                <a-empty v-else />
                <div class="notifier__btns">
                    <a-button type="link" :disabled="!notifications.length" @click="click4readAll">
                        {{ $t('notifier.clear') }}
                    </a-button>
                    <a-divider style="background-color: rgba(52, 81, 148, 0.3)" type="vertical" />
                    <a-button type="link" @click="toNotification">
                        {{ $t('notifier.more') }}
                    </a-button>
                </div>
            </div>
        </template>
    </a-dropdown>
</template>

<script>
import { read, readAll, listUnreadNotifications } from '@/api/system/notification';
export default {
    name: 'LayoutNotifier',
    data() {
        return {
            notifications: [],
            visible: false
        };
    },
    computed: {
        count() {
            return this.$store.state.notification.count;
        }
    },
    created() {
        this.fetchNotifications();
    },
    methods: {
        fetchNotifications() {
            listUnreadNotifications().then((result) => {
                this.notifications = result.notifications;
                this.$store.commit('notification/receiveCount', result.count);
            });
        },
        // onShow(visible) {
        //     if (visible) {
        //         this.fetchNotifications()
        //     }
        // },
        toNotification() {
            this.$router.push({ path: '/system/notification' });
        },
        click4read(item) {
            item.isRead = true;
            read(item.id).then(() => {
                this.fetchNotifications();
            });
        },
        click4handle(item) {
            item.isRead = true;
            read(item.id).then(() => {
                this.fetchNotifications();
                this.$router.push({ path: item.vueRoute });
                this.visible = false;
            });
        },
        click4readAll() {
            this.notifications.forEach((item) => {
                item.isRead = true;
            });
            readAll().then(() => {
                this.fetchNotifications();
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/styles/variables.less';
.icon__notification {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 16px;
    color: @headerIconColor;
    font-size: 20px;
    cursor: pointer;

    &:hover {
        color: @primary-hover;
    }
}
.notifier__container {
    width: 315px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px 4px 10px rgba(0, 35, 84, 0.1);
    border-radius: 4px;
    & > ul {
        max-height: 600px;
        margin-bottom: 0;
        padding-left: 0;
        overflow-y: auto;
        list-style: none;

        li {
            position: relative;
            display: flex;
            align-items: center;
            padding: 0 12px;

            cursor: pointer;

            &:last-child {
                border-bottom: none;
            }
            &.read {
                .notifier__body {
                    opacity: 0.35;
                }
            }
            &:hover {
                background-color: @primary-bg;

                .notifier__operations {
                    display: flex;
                }
            }
            .notifier__icon {
                display: flex;
                flex-grow: 0;
                flex-shrink: 0;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                margin-right: 16px;
                margin-left: -8px;
                overflow: hidden;
                color: #fff;
                background-color: @danger-hover;
                border-radius: 20%;

                .notifier__operations {
                    display: flex;
                }
            }
            .notifier__body {
                width: 100%;
                padding: 18px 0 14px;
                border-bottom: 1px dashed #DADFE9;
                h5,
                p {
                    margin-bottom: 0;
                }
                h5 {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 20px;
                    /* identical to box height */
                    color: #0F307A;
                }
                p {
                    width: 100%;
                    margin-top: 5px;
                    overflow: hidden;
                    font-size: 12px;
                    line-height: 16px;
                    color: #6B6B6B;
                    // white-space: pre;
                    text-overflow: ellipsis;
                }
                .notifier__time {
                    font-size: 12px;
                    line-height: 16px;
                    margin-top: 5px;
                    color: rgba(15, 48, 122, 0.6);
                }
            }
            .notifier__operations {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 1;
                display: none;
                align-items: flex-end;
                justify-content: flex-end;
                padding: 8px 24px 16px;
                // background-color: rgba(0, 0, 0, 0.1);

                /deep/ i {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    margin-left: 16px;
                    font-size: 16px;
                    background-color: #fff;
                    border-radius: 50%;
                    box-shadow: @shadow-1;

                    &:first-child {
                        color: @success;

                        &:hover {
                            color: #fff;
                            background-color: @success;
                        }
                    }
                    &:last-child {
                        color: @primary;

                        &:hover {
                            color: #fff;
                            background-color: @primary;
                        }
                    }
                }
                .read {
                    color: #fff !important;
                    background-color: @success;
                }
            }
        }
    }
}
.notifier__btns {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.1);

    & > button {
        flex: 1;
        height: 40px;
        font-size: 12px;
        color: #000000;
    }
}
/deep/ .ant-empty {
    padding: 64px 0;
}
</style>
